import React, { useState } from 'react';
import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  Paper,
  Popover,
  Tooltip,
} from '@mui/material';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { SelectDefault } from '../../../shared/components/inputs/SelectDefault';
import { TENANT_USER_PROVIDERS } from '../../../shared/constants';
import { ButtonDefault } from '../../../shared/components/ButtonDefault';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  root: {
    minWidth: '120px!important',
  },
});

export type TenantUserFilter = {
  provider: string;
  subscribedUsers: boolean;
};

const INITIAL_VALUES = {
  provider: 'all',
  subscribedUsers: false,
};

export const UserTableFilter: React.FC<{
  provider?: string;
  subscribedUsers?: boolean;
  onChangeFilter: (filter: TenantUserFilter | null) => void;
}> = ({ onChangeFilter, provider, subscribedUsers }) => {
  const classes = useStyles();
  const [filter, setFilter] = useState<TenantUserFilter>(INITIAL_VALUES);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <>
      <Tooltip title="Filtrar por fecha">
        <IconButton onClick={handleClick} style={{ padding: 0 }}>
          <FilterAltOutlinedIcon />
        </IconButton>
      </Tooltip>
      <Popover
        id="simple-popover"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Paper>
          <Box p={2} width={250}>
            <Box mb={2}>
              <SelectDefault
                variant="outlined"
                options={TENANT_USER_PROVIDERS}
                labelName="Proveedor"
                value={filter.provider}
                name="provider"
                defaultValue=""
                onChangeData={(name, value) =>
                  setFilter({
                    ...filter,
                    [name]: value,
                  })
                }
              />
            </Box>
            <Box mb={2}>
              <FormControlLabel
                label="Solo usuario subscriptos"
                control={
                  <Checkbox
                    defaultChecked={INITIAL_VALUES.subscribedUsers}
                    checked={filter.subscribedUsers}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        subscribedUsers: e.target.checked,
                      });
                    }}
                  />
                }
              />
            </Box>
            <Box display="flex" justifyContent="space-between">
              <ButtonDefault
                className={classes.root}
                variant="outlined"
                onClick={() => {
                  onChangeFilter(null);
                  setFilter(INITIAL_VALUES);
                  handleClose();
                }}
              >
                Limpiar
              </ButtonDefault>
              <ButtonDefault
                className={classes.root}
                onClick={() => {
                  onChangeFilter(filter);
                  handleClose();
                }}
              >
                APLICAR
              </ButtonDefault>
            </Box>
          </Box>
        </Paper>
      </Popover>
    </>
  );
};
